module.exports = __webpack_public_path__ + "img/playStore.db9b21a1.png";